import { Icon } from "semantic-ui-react";

export function LoadingSpinner() {
    return <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <Icon name='spinner' color="orange" size='huge' loading /> 
        <br/>
        <p style={{fontSize: '16px'}}>Chargement en cours ...</p>
    </div>
}